const config = {
        // urlApi: 'http://localhost:3001',
        // urlApi:'https://netzero.erdi.cmu.ac.th',
        // urlApi:'http://10.110.23.11:3084', 
        urlApi:'https://apilandscape.erdi.cmu.ac.th', 
        token_name: 'pos_token',
        headers: () => {
                return {
                        headers: {
                               Authorization: `Bearer ${localStorage.getItem(config.token_name) || sessionStorage.getItem(config.token_name)}`,
                        }
                }
        }
}
export default config;